import Icon from '@mui/icons-material/Movie';

import { EditMedia } from './EditMedia';
import { ListMedia } from './ListMedia';

export const MediaResourceConfig = {
  list: ListMedia,
  icon: Icon,
  edit: EditMedia,
  name: 'media',
};
